import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React, { useEffect, useState } from 'react';
import { BiSolidCalendarEdit } from "react-icons/bi";
import { GrDocumentUpdate } from "react-icons/gr";
import { CalendarAPI } from '../../../api/CalendarAPI';
import CourtItem from './CourtItem';
import TimeInputField from './TimeInputField';
import mondayImg from '../../../assets/images/monday.png'
import tuesdayImg from '../../../assets/images/tuesday.png'
import wednesdayImg from '../../../assets/images/wednesday.png'
import thursdayImg from '../../../assets/images/thursday.png'
import fridayImg from '../../../assets/images/friday.png'
import saturdayImg from '../../../assets/images/saturday.png'
import sundayImg from '../../../assets/images/sunday.png'
import openBanner from '../../../assets/images/open.png'
import closedBanner from '../../../assets/images/closed.png'
import { PiCourtBasketballFill } from "react-icons/pi";
import { MdOutlineTimelapse } from "react-icons/md";
import { useSelector } from 'react-redux';
import PopUpAlert from '../../../component/PopUpAlert'
import { ResourceAPI } from '../../../api/ResourceAPI';
import { Privileges } from "../../../util/PrivilegeConstants"
import { SubscriptionAPI } from '../../../api/SubscriptionAPI';
import { UserAPI } from '../../../api/UserAPI';
import SecondLoader from '../../../component/SecondLoader';
import { isClubStaff } from '../../../util/UserRoles';
import { PrivilegeAPI } from '../../../api/PrivilegesAPI'
import Loader from '../../../component/Loader'
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../redux/reducer/rootReducer';
import CustomSwitch from '../../CustomComponents/CustomSwitch/CustomSwitch'


const AdvanceSettings = () => {
  const selectedClub = useSelector((store) => store.user.selectedClub)
  const [calendarConfigId, setCalendarConfigId] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const [openAddCourt, setOpenAddCourt] = useState(false);
  const [courtData, setCourtData] = useState({});
  const [openEditTimeForm, setOpenEditTimeForm] = useState(false);
  const [openSettingEdit, setOpenSettingEdit] = useState(false);
  const [isEditFeature, setIsEditFeature] = useState(false);
  const [isEditRsvp, setIsEditRsvp] = useState(false);
  const [gameData, setGameData] = useState([]);
  const [privileges, setPrivileges] = useState({});
  const [loadingState, setLoadingState] = useState({
    loading1: false,
    loading2: false,
    loading3: false,
    loading4: false,
    loading5: false,
  });
  const [calenderSettings, setCalenderSettings] = useState({
    interval: null,
    calenderTimezone: null,
    timeDetails: [],
    courtDataList: [],
    subscriptionDetails: null,
    isRVPRequired: false,
    scheduleCheckout: false,
    coachPrivacy: false,
    rsvpExpireTime: 0
  });
  const dispatch = useDispatch();

  const handleCalenderSettingData = (key, value) => {
    setCalenderSettings((prev) => ({
      ...prev,
      [key]: value
    }))
  }

  const startLoading = (key) => {
    setLoadingState((prev) => ({
      ...prev,
      [key]: true
    }))
  };

  const finishLoading = (key) => {
    setLoadingState((prev) => ({
      ...prev,
      [key]: false
    }))
  };

  const userInStore = useSelector((state) => state.user);
  let userId = userInStore?.userInfo?.userId;
  const getCalendarConfig = async (clubId) => {
    return await CalendarAPI.getCalendarConfigSettings(clubId)
  };

  const getResourcesAndGame = async (clubId) => {
    return await ResourceAPI.getResourcesAndGame(clubId)
  };

  const getGames = async (clubId) => {
    return await CalendarAPI.getAllGames(clubId)
  };


  const findSubscription = async () => {
    try {

      if (isClubStaff(userInStore?.userInfo)) {
        const response = await UserAPI.getAdminUserID(userInStore.clubId);
        userId = response.Data;
      }
      const subscriptionInfo = await SubscriptionAPI.findSubscription(userInStore.clubId);

      handleCalenderSettingData("subscriptionDetails", subscriptionInfo.Data);
    } catch (error) {
      console.error(error);

    }
  };


  const findAllPrivileges = async () => {
    try {
      startLoading("loading4");
      const reqObj = {
        userId: userInStore.userInfo.userId,
        featureName: Object.keys(Privileges)[9]
      }
      const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
      setPrivileges(response.Data)
    } catch (error) {
      console.error(error);
    } finally {
      finishLoading("loading4");
    }
  };

  useEffect(() => {
    if (userInStore?.userInfo?.userId) {
      findAllPrivileges();
    }
  }, [userInStore?.userInfo?.userId])

  useEffect(() => {
    try {
      if (userInStore.clubId) {
        startLoading("loading3");
        getCalendarConfig(userInStore.clubId).then((response) => {
          handleCalenderSettingData("timeDetails", response.Data.workingDays);
          handleCalenderSettingData("interval", response.Data.interval);
          handleCalenderSettingData("calenderTimezone", response.Data.calenderTimezone);
          handleCalenderSettingData("isRVPRequired", response.Data.rsvprequired);
          handleCalenderSettingData("rsvpExpireTime", response.Data.rsvpExpireInDay);
          handleCalenderSettingData("scheduleCheckout", response.Data.scheduleCheckout);
          handleCalenderSettingData("coachPrivacy", response.Data.coachPrivacy);
          handleCalenderSettingData("isBookingEnabledByDefault", response.Data.isBookingEnabledByDefault);
          setCalendarConfigId(response.Data.calendarConfigId);
          finishLoading("loading3");
        });
      }
    } catch (error) {
      finishLoading("loading3");
    }
    refresh && setRefresh(false);
  }, [refresh, userInStore.clubId]);

  useEffect(() => {
    try {
      if (userInStore.clubId) {
        getGames(userInStore.clubId).then((response) => {
          setGameData(response);
          response && setCourtData({ gameName: response[0].gameId })
        });
      }
    } catch (error) {
    }
  }, [userInStore.clubId]);

  useEffect(() => {
    try {
      if (userInStore.clubId) {
        startLoading("loading1");
        getResourcesAndGame(userInStore.clubId).then((response) => {
          findSubscription();
          handleCalenderSettingData("courtDataList", response.Data)
          finishLoading("loading1");
        });
      }
    } catch (error) {
      finishLoading("loading1")
    }
    setRefresh(false);
  }, [refresh, userInStore.clubId]);

  const handleRefresh = () => {
    setRefresh(true)
  }


  const handleCourtData = (event) => {
    const { name, value } = event.target;
    setCourtData({ ...courtData, [name]: value });
  }
  const addCourtData = async () => {
    const gameResource = {
      gameId: courtData.gameName,
      resourceName: courtData.courtName,
      resourceColor: courtData.courtColor,
      clubId: userInStore.clubId
    }

    try {
      startLoading("loading1");
      await ResourceAPI.postGameResource(gameResource)
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Court ' + courtData.courtName + " is added" }));
      setOpenAddCourt(false);
      setRefresh(true);
      setCourtData({ gameName: gameData[0]?.gameId });
    } catch (error) {
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Contact customer support' }));
      finishLoading("loading1");
    }
  }
  const editTimeData = async () => {
    const calendarConfigTime = {
      calendarConfigId: calendarConfigId,
      workingDays: calenderSettings.timeDetails,
      clubId: userInStore.clubId
    }

    try {
      startLoading("loading3")
      await CalendarAPI.postCalendarTimeConfig(calendarConfigTime);
      setRefresh(true);
      setOpenEditTimeForm(false);
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Calender setting is updated' }));
    } catch (error) {
      finishLoading("loading3");
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Contact customer support' }));
    }

  }


  const updateInterval = async () => {
    try {
      startLoading("loading3")
      setOpenSettingEdit(false)
      const calendarConfigInterval = {
        calendarConfigId: calendarConfigId,
        calendarInterval: calenderSettings.interval,
        clubId: userInStore.clubId
      }
      const calendarTimezoneConfig = {
        calendarConfigId: calendarConfigId,
        calendarTimezone: calenderSettings.calenderTimezone,
        clubId: userInStore.clubId
      }
      await CalendarAPI.postCalendarIntervalConfig(calendarConfigInterval);
      await CalendarAPI.postCalendarTimezoneConfig(calendarTimezoneConfig);
      setRefresh(true)
    } catch (error) {
      finishLoading("loading3");
    }
  }

  const handleUpdateFeature = async () => {
    try {
      const calendarConfigDTO = {
        calendarConfigId: calendarConfigId,
        clubId: userInStore.clubId,
        coachPrivacy: calenderSettings.coachPrivacy,
        scheduleCheckout: calenderSettings.scheduleCheckout,
        isBookingEnabledByDefault: calenderSettings.isBookingEnabledByDefault
      }
      await CalendarAPI.putUpdateCalendarConfigFeature(calendarConfigDTO);
      setRefresh(true);
      setIsEditFeature(false);
      dispatch(rootAction.setIsCheckoutConfigChange(true));
    } catch (error) {
      console.error(error);
    }
  };

  const handleUpdateRSVPConfig = async () => {
    try {
      const calendarConfigDTO = {
        calendarConfigId: calendarConfigId,
        clubId: userInStore.clubId,
        rsvpExpireInDay: calenderSettings.rsvpExpireTime,
        isRSVPRequired: calenderSettings.isRVPRequired
      }
      await CalendarAPI.putUpdateRsvpConfigDetails(calendarConfigDTO);
      setRefresh(true);
      setIsEditRsvp(false);
      dispatch(rootAction.setIsCheckoutConfigChange(true));
    } catch (error) {
      console.error(error);
    }
  };

  const handelCloseAddCourt = () => {
    setOpenAddCourt(false);
    setCourtData({ gameName: gameData[0]?.gameId });
  }
  const filteredTimeDetails = calenderSettings?.timeDetails?.filter((item) => item.isOpen);

  if (loadingState.loading4) {
    return <Loader />
  }

  return (
    <div className='advance_settings_container'>
      {(privileges?.MANAGE_COURT?.includes(Privileges.VIEW)) &&
        <div className="court_details_container">
          <div className="court_details_heading">
            <h1>court name</h1>
            {((calenderSettings?.courtDataList?.length < Number(calenderSettings?.subscriptionDetails?.subscriptionQty) && selectedClub?.calendarType === "RESERVATION_CALENDAR" && privileges?.MANAGE_COURT?.includes(Privileges.CREATE)) || (privileges?.MANAGE_COURT?.includes(Privileges.CREATE) && selectedClub?.calendarType === "EVENT_CALENDAR")) &&
              <>
                {!openAddCourt ?
                  <button data-testid="court_add_btn" onClick={() => setOpenAddCourt(true)} className="bookmarkBtn">
                    <span className="IconContainer">
                      <PiCourtBasketballFill className='court_name_edit_icon' />
                    </span>
                    <p className="court_edit_btn_text">Add</p>
                  </button>
                  :
                  <button onClick={handelCloseAddCourt} data-testid="court_details_cancel_btn" className="court_details_cancel_btn">
                    <span className="court_details_cancel_btn_icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="15" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"></path></svg>
                    </span>
                    <span className="court_details_cancel_text">Cancel</span>
                  </button>
                }
              </>
            }
          </div>
          {loadingState.loading1
            ?
            <SecondLoader />
            :
            <>
              {openAddCourt &&
                <div className="court_details_add_container">
                  <div className="court_details_add_form">
                    <FormControl sx={{
                      width: '40%',
                      '@media (max-width:700px)': {
                        width: '100%'
                      }
                    }} className='calender-setting-select-input'>
                      <InputLabel id="demo-simple-select-label">Select Game Name</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="gameName"
                        label="Select Game Name"
                        name='gameName'
                        value={courtData.gameName || ''}
                        onChange={handleCourtData}
                      >
                        {gameData?.map((item, index) =>
                          <MenuItem key={item.gameId} value={item.gameId} > {item.gameName} </MenuItem>
                        )}

                      </Select>
                    </FormControl>
                    <TextField
                      onChange={handleCourtData}
                      value={courtData.courtName || ''}
                      name='courtName'
                      sx={{
                        width: '30%',
                        '@media (max-width:700px)': {
                          width: '100%'
                        }
                      }}
                      variant='outlined'
                      label='Court Name'
                      className='calender-setting-text-input' />

                    <TextField
                      sx={{
                        width: '25%'
                      }}
                      type='color'
                      onChange={handleCourtData}
                      value={courtData.courtColor || ''}
                      name='courtColor' color='warning'
                      variant='outlined'
                      label='Court Color'
                      className='calender-setting-text-input' />

                  </div>
                  <div className='court_details_add_btn'>
                    <Button onClick={addCourtData} size='medium' variant='contained'>Add</Button>
                  </div>

                </div>}
              {calenderSettings?.courtDataList?.map((item, index) =>
                <CourtItem key={index}
                  startLoading={startLoading}
                  finishLoading={finishLoading}
                  court={item}
                  gameData={gameData}
                  refreshFunc={handleRefresh}
                  setRefresh={setRefresh}
                  privileges={privileges}
                />
              )}
            </>}
        </div>}

      {privileges?.MANAGE_CLUB_TIME?.includes(Privileges.VIEW) &&
        <div className="time_management_container">
          <div className="time_management_heading">
            <h1>manage time</h1>
            {privileges?.MANAGE_CLUB_TIME?.includes(Privileges.MODIFY) &&
              <>
                {!openEditTimeForm
                  ?
                  <button onClick={() => setOpenEditTimeForm(true)} data-testid="court_details_edit_btn" className="bookmarkBtn">
                    <span className="IconContainer">
                      <BiSolidCalendarEdit className='court_name_edit_icon' />
                    </span>
                    <p className="court_edit_btn_text">Edit</p>
                  </button>
                  :
                  <button data-testid="court_details_cancel_btn" onClick={() => setOpenEditTimeForm(false)} className="court_details_cancel_btn">
                    <span className="court_details_cancel_btn_icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="15" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"></path></svg>
                    </span>
                    <span className="court_details_cancel_text">Cancel</span>
                  </button>}
              </>}
          </div>
          {loadingState.loading3 ?
            <SecondLoader />
            :
            <>
              {!openEditTimeForm
                ?
                <>
                  <table className='schedule_table_details'>
                    <thead className='schedule_table_details_header'>
                      <tr>
                        <th>Day</th>
                        <th>Open</th>
                        <th>Close</th>
                      </tr>
                    </thead>
                    <tbody className='schedule_table_details_body'>
                      {filteredTimeDetails.map((item, index) =>
                        <tr key={index}>
                          {item.day == 1 && <td id='schedule_day_name'><span><img src={mondayImg} alt="" />Monday</span></td>}
                          {item.day == 2 && <td id='schedule_day_name'><span><img src={tuesdayImg} alt="" />Tuesday</span></td>}
                          {item.day == 0 && <td id='schedule_day_name'><span><img src={sundayImg} alt="" />Sunday</span></td>}
                          {item.day == 3 && <td id='schedule_day_name'><span><img src={wednesdayImg} alt="" />Wednesday</span></td>}
                          {item.day == 4 && <td id='schedule_day_name'><span><img src={thursdayImg} alt="" />Thursday</span></td>}
                          {item.day == 5 && <td id='schedule_day_name'><span><img src={fridayImg} alt="" />Friday</span></td>}
                          {item.day == 6 && <td id='schedule_day_name'><span><img src={saturdayImg} alt="" />Saturday</span></td>}
                          <td id='schedule_day_open'><span><img src={openBanner} alt="" />
                            {Number(item.startHour.slice(0, 2)) <= 12
                              ?
                              item.startHour
                              :
                              Number(item.startHour.slice(0, 2)) - 12 + ':' + item.startHour.slice(3)
                            }
                            {Number(item.startHour.slice(0, 2)) < 12 ? 'am' : 'pm'}
                          </span>
                          </td>
                          <td id='schedule_day_close'><span><img src={closedBanner} alt="" />
                            {Number(item.endHour.slice(0, 2)) <= 12
                              ?
                              item.endHour
                              :
                              (Number(item.endHour.slice(0, 2)) - 12 < 10 ? '0' + (Number(item.endHour.slice(0, 2)) - 12) : (Number(item.endHour.slice(0, 2)) - 12)) + ':' + item.endHour.slice(3)
                            }
                            {Number(item.endHour.slice(0, 2)) < 12 ? 'am' : 'pm'}
                          </span>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </>
                :
                <div className="time_management_edit_container">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['TimePicker']}>
                      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 10 }}>
                        <TimeInputField data={calenderSettings?.timeDetails} setData={handleCalenderSettingData} />
                      </div>
                    </DemoContainer>
                  </LocalizationProvider>
                  <div className='time_management_edit_save_btn'>
                    <Button onClick={editTimeData} sx={{
                      width: 'max-content',
                      '@media (max-width:400px)': {
                        width: '100%',
                      },
                    }} size='large' variant='contained'><GrDocumentUpdate className='save_time_details_icon' />Save</Button>
                  </div>
                </div>
              }
            </>}
        </div>}
      {privileges?.MANAGE_TIMEZONE_INTERVAL?.includes(Privileges.VIEW) &&
        <div className="scheduler_setting_container">
          <div className="scheduler_setting_heading">
            <h3>Timezone and Interval</h3>
            {privileges?.MANAGE_TIMEZONE_INTERVAL?.includes(Privileges.MODIFY) &&
              <>
                {!openSettingEdit
                  ?
                  <button onClick={() => setOpenSettingEdit(true)} data-testid="schedule_edit_btn" className="bookmarkBtn">
                    <span className="IconContainer">
                      <MdOutlineTimelapse className='court_name_edit_icon' />
                    </span>
                    <p className="court_edit_btn_text">Edit</p>
                  </button>
                  :
                  <button data-testid="schedule_cancel_btn" onClick={() => setOpenSettingEdit(false)} className="court_details_cancel_btn">
                    <span className="court_details_cancel_btn_icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="15" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"></path></svg>
                    </span>
                    <span className="court_details_cancel_text">Cancel</span>
                  </button>}
              </>
            }
          </div>
          {loadingState.loading3 ?
            <SecondLoader />
            :
            <>
              {!openSettingEdit
                ?
                <div className='scheduler_setting_details_container'>
                  <div className='scheduler_setting_details'>
                    <p className='scheduler_setting_interval'>Reservation slot time interval <span>{calenderSettings?.interval / 60} Hour</span></p>
                  </div>
                  <div className='scheduler_setting_details'>
                    <p className='scheduler_setting_interval'>Timezone <span>{calenderSettings?.calenderTimezone}</span></p>
                  </div>
                </div>
                :
                <div className='scheduler_setting_edit_container'>
                  <div className='scheduler_setting_edit_container_input'>
                    <FormControl fullWidth className='calender-setting-select-input'>
                      <InputLabel id="demo-simple-select-label">Reservation Slot Time Interval</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="interval"
                        label="Reservation Slot Time Interval"
                        name='interval'
                        value={calenderSettings?.interval || ''}
                        onChange={(e) => handleCalenderSettingData("interval", e.target.value)}
                      >
                        <MenuItem value={30}>0.5 Hours</MenuItem>
                        <MenuItem value={60}>1 Hours</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl fullWidth className='calender-setting-select-input'>
                      <InputLabel id="demo-simple-select-label">Calender Timezone</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="calenderTimezone"
                        label="Calender Timezone"
                        name='calenderTimezone'
                        value={calenderSettings?.calenderTimezone || ''}
                        onChange={(e) => handleCalenderSettingData("calenderTimezone", e.target.value)}
                      >
                        <MenuItem value="America/Chicago">Chicago</MenuItem>
                        <MenuItem value="America/New_York">New York</MenuItem>
                        <MenuItem value="America/Los_Angeles">Los Angeles</MenuItem>
                        <MenuItem value="America/Anchorage">Anchorage</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className='save-interval-button'>
                    <Button
                      onClick={updateInterval}
                      variant='contained'>Save</Button>
                  </div>
                </div>
              }
            </>}
        </div>}
      <div className="scheduler_setting_container">
        <div className="scheduler_setting_heading">
          <h3>Features</h3>
          {privileges?.MANAGE_TIMEZONE_INTERVAL?.includes(Privileges.MODIFY) &&
            <>
              {!isEditFeature
                ?
                <button onClick={() => setIsEditFeature(true)} data-testid="schedule_edit_btn" className="bookmarkBtn">
                  <span className="IconContainer">
                    <MdOutlineTimelapse className='court_name_edit_icon' />
                  </span>
                  <p className="court_edit_btn_text">Edit</p>
                </button>
                :
                <button data-testid="schedule_cancel_btn" onClick={() => setIsEditFeature(false)} className="court_details_cancel_btn">
                  <span className="court_details_cancel_btn_icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="15" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"></path></svg>
                  </span>
                  <span className="court_details_cancel_text">Cancel</span>
                </button>}
            </>
          }
        </div>
        {loadingState.loading3 ?
          <SecondLoader />
          :
          <>
            {!isEditFeature
              ?
              <div className='scheduler_setting_details_container'>
                <div className='scheduler_setting_details'>
                  <p className='scheduler_setting_interval'>Enable coach privacy <span>{calenderSettings?.coachPrivacy ? 'Yes' : 'No'}</span></p>
                </div>
                <div className='scheduler_setting_details'>
                  <p className='scheduler_setting_interval'>Enable schedule checkout <span>{calenderSettings?.scheduleCheckout ? 'Yes' : 'No'}</span></p>
                </div>
                <div className='scheduler_setting_details'>
                  <p className='scheduler_setting_interval'>Allow newly registered users to book schedules by default.<span>{calenderSettings?.isBookingEnabledByDefault ? 'Yes' : 'No'}</span></p>
                </div>
              </div>
              :
              <div className='scheduler_setting_edit_container'>
                <div className='scheduler_setting_edit_feature_input'>
                  <p>Enable coach privacy </p>
                  <CustomSwitch checked={calenderSettings?.coachPrivacy} onChange={(e) => handleCalenderSettingData("coachPrivacy", e.target.checked)} />
                </div>
                <div className='scheduler_setting_edit_feature_input'>
                  <p>Enable schedule checkout</p>
                  <CustomSwitch checked={calenderSettings?.scheduleCheckout} onChange={(e) => handleCalenderSettingData("scheduleCheckout", e.target.checked)} />
                </div>
                <div className='scheduler_setting_edit_feature_input'>
                  <p>Allow newly registered users to book schedules by default.</p>
                  <CustomSwitch checked={calenderSettings?.isBookingEnabledByDefault} onChange={(e) => 
                    handleCalenderSettingData("isBookingEnabledByDefault", e.target.checked)} />
                </div>
                <div className='save-interval-button'>
                  <Button
                    onClick={handleUpdateFeature}
                    variant='contained'>Save</Button>
                </div>
              </div>
            }
          </>}

      </div>

      <div className="scheduler_setting_container">
        <div className="scheduler_setting_heading">
          <h3>RSVP</h3>
          {!isEditRsvp
            ?
            <button onClick={() => setIsEditRsvp(true)} data-testid="schedule_edit_btn" className="bookmarkBtn">
              <span className="IconContainer">
                <MdOutlineTimelapse className='court_name_edit_icon' />
              </span>
              <p className="court_edit_btn_text">Edit</p>
            </button>
            :
            <button data-testid="schedule_cancel_btn" onClick={() => setIsEditRsvp(false)} className="court_details_cancel_btn">
              <span className="court_details_cancel_btn_icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="15" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"></path></svg>
              </span>
              <span className="court_details_cancel_text">Cancel</span>
            </button>}
        </div>
        {loadingState.loading3 ?
          <SecondLoader />
          :
          <>
            {!isEditRsvp
              ?
              <div className='scheduler_setting_details_container'>
                <div className='scheduler_setting_details'>
                  <p className='scheduler_setting_interval'>Enable RSVP <span>{calenderSettings?.isRVPRequired ? 'Yes' : 'No'}</span></p>
                </div>
                {calenderSettings?.isRVPRequired &&
                  <div className='scheduler_setting_details'>
                    <p className='scheduler_setting_interval'>RSVP Cutoff Time<span>{calenderSettings?.rsvpExpireTime > 0 ? calenderSettings?.rsvpExpireTime : ''} {calenderSettings?.rsvpExpireTime === 0 ? 'Never Expire' : calenderSettings?.rsvpExpireTime === 1 ? 'Day' : 'Days'}</span></p>
                  </div>}
              </div>
              :
              <div className='scheduler_setting_edit_container'>
                <div className='scheduler_setting_edit_feature_input'>
                  <p>Enable RSVP</p>
                  <CustomSwitch checked={calenderSettings?.isRVPRequired} onChange={(e) => handleCalenderSettingData("isRVPRequired", e.target.checked)} />
                </div>
                {calenderSettings?.isRVPRequired &&
                  <div className='scheduler_setting_edit_feature_input'>
                    <p>RSVP Cutoff Time</p>
                    <FormControl data-testid="game-dropdown" className='calender-game-dropdown' sx={{ m: 1 }}>
                      <Select
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        size='small'
                        value={calenderSettings?.rsvpExpireTime || 0}
                        onChange={(e) => handleCalenderSettingData("rsvpExpireTime", e.target.value)}
                        autoWidth

                      >
                        {[0, 1, 2, 3].map((item) => (
                          <MenuItem key={item} value={item}>
                            {item > 0 ? item : ''} {item === 0 ? 'Never Expire' : item === 1 ? 'Day' : 'Days'}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>}
                <div className='save-interval-button'>
                  <Button
                    onClick={handleUpdateRSVPConfig}
                    variant='contained'>Save</Button>
                </div>
              </div>
            }
          </>}

      </div>
    </div>
  )
}

export default AdvanceSettings